import React from 'react';
import RawHTML from '~/components/jsx-helpers/raw-html';
import { FormattedMessage } from 'react-intl';
import { Authors, PublicationInfo, ErrataSection } from '../../common/common';
import GetThisTitle from '../../common/get-this-title';
import LetUsKnow from '../../common/let-us-know/let-us-know';
import SavingsBlurb from '../../common/savings-blurb';
import Promo from '../promo';
import './details-tab.scss';
function PolishTab({ model }) {
    return (React.createElement("div", { className: "details-tab" },
        React.createElement("div", { className: "sidebar" },
            React.createElement("div", null,
                React.createElement("h3", null, "Przejd\u017A do ksi\u0105\u017Cki"),
                React.createElement(GetThisTitle, { model: model })),
            React.createElement("div", { className: "let-us-know-region" },
                React.createElement(LetUsKnow, { title: model.title }))),
        React.createElement("div", { className: "main" },
            React.createElement("div", { className: "loc-summary-text" },
                React.createElement("h3", null, "Podsumowanie"),
                React.createElement(RawHTML, { html: model.description })),
            React.createElement(Authors, null),
            React.createElement(ErrataSection, null),
            React.createElement(PublicationInfo, { polish: true }))));
}
function EnglishTab({ model }) {
    return (React.createElement("div", { className: "details-tab" },
        React.createElement("div", { className: "sidebar" },
            React.createElement("div", null,
                React.createElement("h3", null,
                    React.createElement(FormattedMessage, { id: "getTheBook", defaultMessage: "Get the book" })),
                React.createElement(GetThisTitle, { model: model })),
            React.createElement("div", { className: "let-us-know-region" },
                React.createElement(LetUsKnow, { title: model.salesforceAbbreviation }))),
        React.createElement("div", { className: "main" },
            React.createElement(Promo, { promoteSnippet: model.promoteSnippet }),
            React.createElement("div", { className: "loc-summary-text" },
                React.createElement("h3", null,
                    React.createElement(FormattedMessage, { id: "summary", defaultMessage: "Summary" })),
                React.createElement(RawHTML, { html: model.description })),
            React.createElement(Authors, null),
            React.createElement(ErrataSection, null),
            React.createElement("div", { className: "publication-info" },
                React.createElement(PublicationInfo, { url: null })),
            model.adoptions && React.createElement(SavingsBlurb, null))));
}
export default function DetailsTab({ model, polish }) {
    const Child = polish ? PolishTab : EnglishTab;
    return React.createElement(Child, { model: model });
}
